import React from "react";

const ContinuePage = () => {
    const handleFinalContinue = () => {
        sessionStorage.setItem("allowSite", "true");

        const targetUrl = window.location.origin + "/home?access=granted";

        if (navigator.userAgent.match(/Android/i)) {
            window.location.href = `intent://${targetUrl.replace(/^https?:\/\//, "")}#Intent;scheme=https;package=com.android.chrome;end`;
        } else {
            window.location.href = targetUrl;
        }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>
                Welcome to kitchenware,<br />Appliances
            </h1>

            <button style={styles.enterBtn} onClick={handleFinalContinue}>
                Enter Site
            </button>

            <p style={styles.subText}>
                Premium Products • Quality • Style
            </p>
        </div>
    );
};

const styles = {
    container: {
        height: "100vh",
        backgroundColor: "#ffffffff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "20px",
        fontFamily: "sans-serif",
    },
    heading: {
        fontSize: "28px",
        fontWeight: "600",
        marginBottom: "30px",
    },
    enterBtn: {
        backgroundColor: "#1F74BA",
        color: "#fff",
        padding: "14px 40px",
        borderRadius: "40px",
        border: "none",
        fontSize: "16px",
        cursor: "pointer",
    },
    subText: {
        marginTop: "20px",
        fontSize: "13px",
        color: "#555",
    }
};

export default ContinuePage;